/**
 * Pufien — ürün sayfasında SOMUT teslimat tarihi.
 *
 * ÇIKTI (Sepete Ekle'nin altındaki kutu):
 *   ana satır : "Bugün 13:00'a kadar sipariş verirsen 12 Ağustos Çarşamba kapında."
 *               Kesim saati geçtiyse veya hafta sonuysa aynı-gün vaadi YALAN olur,
 *               o yüzden: "Şimdi sipariş verirsen 12 Ağustos Çarşamba kapında."
 *   alt satır : "Bugün kargoda" / "Yarın kargoda" / "Pazartesi kargoda"
 *
 * NEDEN JS, NEDEN LIQUID DEĞİL:
 *   Shopify CDN sayfaları agresif cache'liyor. Liquid ile yazılan saat DONAR:
 *   12:00'de cache'lenen sayfa 16:00'da hâlâ "Bugün kargoda" derdi → müşteriye yalan.
 *   Bu yüzden hesap TARAYICIDA, sayfa her açıldığında yapılıyor.
 *
 * NEDEN Europe/Istanbul:
 *   Kesim saati DEPONUN saati. Ziyaretçi Almanya'da/ABD'de olsa bile tarih
 *   değişmemeli. Intl.DateTimeFormat ile İstanbul'un takvim günü ve saati
 *   çıkarılıyor; cihazın saat dilimi hesaba HİÇ girmiyor.
 *
 * KURALLAR
 *   Kesim saati              : 13:00  (data-pf-cutoff ile değiştirilebilir)
 *   İş günü + 13:00 ÖNCESİ   → AYNI gün kargoda
 *   13:00 SONRASI            → ertesi İŞ GÜNÜ kargoda
 *   Cumartesi/Pazar iş günü DEĞİL → Pazartesi'ye yuvarlanır
 *     (Cuma 13:00 sonrası → "Pazartesi kargoda". "Yarın kargoda" demek yalan olurdu.)
 *   Teslim                   : kargo gününden sonra 2 İŞ GÜNÜ
 *                              (data-pf-transit ile değiştirilebilir)
 *     Çarşamba kargo → Perşembe(1), Cuma(2)      = Cuma teslim
 *     Perşembe kargo → Cuma(1), Pazartesi(2)     = Pazartesi teslim
 *     Cuma kargo     → Pazartesi(1), Salı(2)     = Salı teslim
 *
 * NOT: saat her zaman "HH:00" biçiminde yazılıyor; okunuşu "… sıfır sıfır" ile
 * bittiği için Türkçe yönelme eki DAİMA 'a olur ("13:00'a", "15:00'a"). Bu yüzden
 * ek sabit; kesim saati değişse bile dilbilgisi bozulmaz.
 */
(function () {
  var TZ = 'Europe/Istanbul';
  var DEFAULT_CUTOFF_HOUR = 13;
  var DEFAULT_TRANSIT_DAYS = 2;

  var DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var MONTHS = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
  ];

  /** İstanbul'un takvim günü + saati — ziyaretçinin saat diliminden bağımsız. */
  function istanbulNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());

    var get = function (type) {
      var p = parts.find(function (x) { return x.type === type; });
      return p ? parseInt(p.value, 10) : 0;
    };

    // hour12:false bazı tarayıcılarda gece yarısını "24" verir
    var hour = get('hour');
    if (hour === 24) hour = 0;

    return { year: get('year'), month: get('month'), day: get('day'), hour: hour };
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  function isWeekend(date) {
    var g = date.getDay();
    return g === 0 || g === 6; // Pazar veya Cumartesi
  }

  /** Hafta sonuna düştüyse ileri sar; iş günüyse olduğu gibi bırak. */
  function rollToBusinessDay(date) {
    var d = new Date(date.getTime());
    while (isWeekend(d)) d = addDays(d, 1);
    return d;
  }

  /** n İŞ GÜNÜ ekle (hafta sonları sayılmaz). */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    for (var i = 0; i < n; i++) {
      d = rollToBusinessDay(addDays(d, 1));
    }
    return d;
  }

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  /** <time datetime="…"> için makine okunur tarih. */
  function isoDate(d) {
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }

  /** "12 Ağustos Çarşamba" */
  function trDate(d) {
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + DAYS[d.getDay()];
  }

  /**
   * Saf hesap — DOM'a dokunmaz, test edilebilir.
   * @param {number} cutoffHour   kesim saati (0-23)
   * @param {number} transitDays  kargodan sonra kaç İŞ GÜNÜ
   * @param {object} [nowOverride] {year, month, day, hour} — sadece test için
   */
  function compute(cutoffHour, transitDays, nowOverride) {
    var now = nowOverride || istanbulNow();
    // Yalnızca gün aritmetiği yapılacağı için yerel gece yarısı yeterli:
    // gün/ay/yıl zaten İstanbul'dan geldi, saat dilimi bir daha devreye girmiyor.
    var today = new Date(now.year, now.month - 1, now.day);

    // --- Kargoya veriliş günü ---
    var sameDay = !isWeekend(today) && now.hour < cutoffHour;
    var ship = sameDay ? today : rollToBusinessDay(addDays(today, 1));

    // --- Teslim günü: kargo + N iş günü ---
    var eta = addBusinessDays(ship, transitDays);

    // --- Alt satır etiketi ---
    var diffDays = Math.round((ship - today) / 86400000);
    var shipLabel;
    if (diffDays === 0) {
      shipLabel = 'Bugün kargoda';
    } else if (diffDays === 1) {
      shipLabel = 'Yarın kargoda';
    } else {
      shipLabel = DAYS[ship.getDay()] + ' kargoda'; // "Pazartesi kargoda"
    }

    // --- Ana satır ---
    var dateHtml =
      '<strong><time datetime="' + isoDate(eta) + '">' + trDate(eta) + '</time></strong>';
    var etaHtml = sameDay
      ? 'Bugün <strong>' + pad2(cutoffHour) + ":00</strong>'a kadar sipariş verirsen " +
        dateHtml + ' kapında.'
      : 'Şimdi sipariş verirsen ' + dateHtml + ' kapında.';

    return {
      sameDay: sameDay,
      ship: ship,
      eta: eta,
      shipLabel: shipLabel,
      etaHtml: etaHtml,
      etaText: sameDay
        ? 'Bugün ' + pad2(cutoffHour) + ":00'a kadar sipariş verirsen " + trDate(eta) + ' kapında.'
        : 'Şimdi sipariş verirsen ' + trDate(eta) + ' kapında.',
    };
  }

  function intAttr(el, name, fallback) {
    if (!el) return fallback;
    var raw = el.getAttribute(name);
    if (raw == null || raw === '') return fallback;
    var n = parseInt(raw, 10);
    return isNaN(n) ? fallback : n;
  }

  function fillPair(etaEl, shipEl, box) {
    var cutoff = intAttr(box, 'data-pf-cutoff', DEFAULT_CUTOFF_HOUR);
    var transit = intAttr(box, 'data-pf-transit', DEFAULT_TRANSIT_DAYS);
    if (cutoff < 0 || cutoff > 23) cutoff = DEFAULT_CUTOFF_HOUR;
    if (transit < 0 || transit > 30) transit = DEFAULT_TRANSIT_DAYS;

    var r = compute(cutoff, transit);

    if (etaEl) {
      etaEl.innerHTML = r.etaHtml;
      etaEl.removeAttribute('hidden');
      etaEl.setAttribute('data-pf-ready', '1');
    }
    if (shipEl) {
      shipEl.textContent = r.shipLabel;
      shipEl.removeAttribute('hidden');
      shipEl.setAttribute('data-pf-ready', '1');
    }
    if (box) box.setAttribute('data-pf-ready', '1');
  }

  function render() {
    var filled = 0;

    // Normal yol: her kutu kendi ayarını taşır.
    var boxes = document.querySelectorAll('[data-pf-delivery]:not([data-pf-ready])');
    for (var i = 0; i < boxes.length; i++) {
      fillPair(
        boxes[i].querySelector('[data-pf-eta]'),
        boxes[i].querySelector('[data-pf-ship]'),
        boxes[i]
      );
      filled++;
    }

    // Yedek yol: CDN'de hâlâ ESKİ snippet HTML'i varsa (deploy anı) kutu
    // sarmalayıcısı olmayabilir — yine de tarihi bas, kimse boş kutu görmesin.
    var orphans = document.querySelectorAll('[data-pf-eta]:not([data-pf-ready])');
    for (var j = 0; j < orphans.length; j++) {
      var el = orphans[j];
      var box = el.closest ? el.closest('[data-pf-delivery]') : null;
      var parent = el.parentNode;
      fillPair(el, parent ? parent.querySelector('[data-pf-ship]') : null, box);
      filled++;
    }

    return filled;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // Horizon bölümleri morph / section-render ile yeniden çiziliyor (varyant
  // değişimi, tema editörü, sepet güncellemesi). Yeniden çizilen HTML Liquid
  // yedek metnini geri getirir; aşağıdaki iki kanca tarihi tekrar basar.
  document.addEventListener('shopify:section:load', render);

  if (typeof MutationObserver === 'function') {
    // NOT: rAF'i window'dan koparıp çağırmak ("Illegal invocation") patlar,
    // bu yüzden her zaman window üzerinden çağrılıyor.
    var schedule = function (fn) {
      if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(fn);
      else window.setTimeout(fn, 0);
    };
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // Morph bittikten sonra tek seferde çalış; innerHTML yazmak yeni mutation
      // doğurur ama o turda ":not([data-pf-ready])" boş döner → döngü kapanır.
      schedule(function () {
        scheduled = false;
        render();
      });
    });
    var startObserving = function () {
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) startObserving();
    else document.addEventListener('DOMContentLoaded', startObserving);
  }

  // QA kancası: konsoldan pfShippingEta.compute(13, 2, {year:2026,month:8,day:7,hour:14})
  window.pfShippingEta = { compute: compute, render: render };
})();
